<section>
  <div class="border_container">
    <div class="row align-items-center border mx-0 p-1">
      <div class="col d-flex justify-content-end">
        <app-custom-button [label]="'Aplicar Anticipos'" [severity]="'success'" [disabled]="disabledDetail"
          [width]="'8.5rem'" (onClick)="openAdvancePaymentsSelectionModal()"></app-custom-button>
        <app-custom-modal #advancePaymentsSelection [label]="'Seleccionar'" [children]="componentTableSelection"
          [header]="'Anticipos no aplicados en este recibo'" [inputs$]="inputsForAdvancePaymentsSelection$"
          [output$]="output$" [width]="'50rem'" (selectedItems)="handleSelectedItem($event)" hidden></app-custom-modal>
      </div>
    </div>
    <div [hidden]="!isFormView">
      <form novalidate [formGroup]="formAdvancePayment">
        <div class="row px-1 mb-2">
          <div class="col field-cash-receipt">
            <app-custom-input-text formControlName="cashReceipt" [labelText]="'Anticipo'">
            </app-custom-input-text>
          </div>
          <div class="col field-residue-value">
            <app-custom-input-decimal formControlName="residueValue" [labelText]="'Saldo'">
            </app-custom-input-decimal>
          </div>
          <div class="col field-total-value">
            <app-custom-input-decimal formControlName="appliedValue" [labelText]="'Vr.Aplicado'" [required]="true"
              (onChangeNumber)="changeAppliedValue()"></app-custom-input-decimal>
          </div>
          <div class="col field-save-button">
            <app-custom-button [title]="'Guardar'" [label]="'Guardar'" [severity]="'success'"
              [disabled]="disabledDetail" (onClick)="send()">
            </app-custom-button>
          </div>
          <div class="col field-cancel-button">
            <app-custom-button [title]="'Cancelar'" [label]="'Cancelar'" [severity]="'danger'"
              [disabled]="disabledDetail" (onClick)="cancel()">
            </app-custom-button>
          </div>
        </div>
      </form>
    </div>
    <div class="col-12">
      <app-custom-table [headers]="detailHeader" [data]="detailData" [actions]="tableActions"
        [showCheckbox]=" !this.disabledDetail " [checkBoxAction]="checkboxActions"
        [clearSelectionTrigger]="clearSelectionTrigger" (onPageChange)="onPageChange($event)"
        (onAction)="onAction($event)">
      </app-custom-table>
    </div>
  </div>
</section>